import React, { useEffect } from 'react';
import { Fade } from '../../animation/animation';
import styles from './server-error.module.scss';

import { sendPostMessage } from '../../utils/library';
import { CLOSE_WITH_ERROR } from '../../constants';

interface ErrorScreenProps {
	code: number
}

export default function ErrorScreen({code}:ErrorScreenProps) {
		var message:string;

		switch (code) {
			case 404: {
				message = 'Запрашиваемые данные не найдены';
				break;
			}
			case 403: {
				message = 'Данные не доступны для этого домена';
				break;
			}
			default: {
				message = 'Ошибка соединения с сервером. Попробуйте позже';
			}
		}

	useEffect(() => {
		if (code) sendPostMessage({ type: CLOSE_WITH_ERROR, payload: { message: `${code}. ${message}` }});
	}, [code, message]);

	return (<Fade duration={500} when={code != undefined}>
		<div className={styles.default}><h1>{`Ошибка ${code}. ${message}`}</h1></div>
	</Fade>)
}